/** Eternal City copy, ru. Machine assisted from the English, pending review; proper names and {placeholders} kept as in English. NPC dialogue stays English. */
export const cityRu: Record<string, string> = {
  'city.seoDescription': 'Войдите в живый город. Каждый человек выполняет свой ежедневный обычай. Следуйте за ними, говорите с ними, и проводите день с людьми, которые живут без вас.',
  'city.intro': 'Это живой город.Все здесь соблюдают ежедневную рутину, и время проходит, когда вы играете.',
  'city.back': 'Возвращение в мир',
  'city.connecting': 'Открытие городских ворот...',
  'city.reconnecting': 'Я потерял нить.',
  'city.offline': 'Город сейчас недоступен, попробуйте еще раз.',
  'city.signinTitle': 'Зарегистрируйтесь , чтобы войти .',
  'city.signinBody': 'В городе твое место, твой дневник и люди, с которыми ты встречаешься, сохранены для твоего учета.',
  'city.signinCta': 'Подпишитесь',
  'city.privacy': 'Как мы обращаемся с этими данными: Политика конфиденциальности',
  'city.blocked': 'Если вы думаете, что это ошибка, пожалуйста, свяжитесь с поддержкой.',
  'city.openElsewhere': 'Этот город открыт в другом отчете.',
  'city.canvasLabel': 'Изометрическая карта {city}. Используйте списки рядом, чтобы поговорить, ходить и смотреть вокруг.',
  'city.hint': 'Нажмите на землю, чтобы ходить, или нажмите на человека, чтобы поговорить.',
  'city.holiday': 'Сегодня: {name}',
  'city.here': 'Ты в {place}.',
  'city.commons.empty': 'Это общее пространство, и других путешественников здесь сейчас нет.',
  'city.commons.here.one': 'Это общее пространство, и здесь еще один путешественник.',
  'city.commons.here.other': 'Это общее пространство, и {count} Пришли другие путешественники.',
  'city.commons.peer': 'товарищ по путешествию',
  'city.crowd.name': 'Городской житель',
  'city.travel.ride': 'Поехать . {place} (около {n} минуты)',
  'city.wares.now': 'Теперь я выложил: {list}',
  'city.wares.none': 'Ничего не выложено в это время .',
  'city.wares.few': '{name} (некоторые остались)',
  'city.wares.last': '{name} (последний)',
  'city.places': 'Иди куда-нибудь.',
  'city.goPlace': 'Иди в {place}',
  'city.dialogueAnnounce': 'Выборы объявляются, как они появляются.',
  'city.people': 'Кто здесь?',
  'city.peopleNone': 'Никого не видно.',
  'city.talk': 'Поговори .',
  'city.goto': 'Прогуляйтесь .',
  'city.away': '{n} шаги в сторону',
  'city.scenes': 'Случается недалеко',
  'city.watch': 'Присоединяйтесь .',
  'city.props': 'Посмотрите вокруг.',
  'city.examine': 'Посмотрите.',
  'city.open': 'Открыто',
  'city.take': 'Возьми .',
  'city.menu.open': 'Открыто {thing}',
  'city.menu.take': 'Возьми то, что в ней. {thing}',
  'city.menu.walkToThing': 'Прогуляйтесь . {thing}',
  'city.dialogue': 'Разговор',
  'city.close': 'Ближе .',
  'city.leave': 'Оставьте разговор.',
  'city.menu.talk': 'Поговори с {name}',
  'city.menu.walkTalk': 'Пройди к нему. {name}',
  'city.menu.walkTo': 'Прогуляйтесь . {name}',
  'city.menu.walkHere': 'Иди сюда.',
  'city.menu.swimHere': 'Плыви здесь.',
  'city.menu.rowHere': 'Прилечь сюда .',
  'city.mount.down': 'Спустись. {name}',
  'city.companion.home': 'Пошлите {name} дом',
  'city.rumours.title': 'Доска слухов',
  'city.rumours.none': 'Стоять рядом с горожанами, разговаривая вместе, в таверне, и то, что они говорят, закреплено здесь.',
  'city.rumours.said': 'сказал {name}',
  'city.greet.title': 'Известный по имени',
  'city.greet.callMe': 'Как тебя называют горожане?',
  'city.greet.placeholder': 'Твое имя.',
  'city.greet.none': 'Пока тебя никто не знает. Остановитесь и поговорите с кем-то, и в следующий раз они приветствуют вас по имени.',
  'city.greet.morning.0': 'Утром. {name}!',
  'city.greet.morning.1': 'Доброе утро. {name}.',
  'city.greet.morning.2': 'Встать рано. {name}?',
  'city.greet.afternoon.0': 'Добрый день. {name}.',
  'city.greet.afternoon.1': 'Добрый день. {name}!',
  'city.greet.afternoon.2': 'Хорошо встретились. {name}.',
  'city.greet.evening.0': 'Вечером, {name}.',
  'city.greet.evening.1': 'Добрый вечер. {name}!',
  'city.greet.evening.2': 'Уезжайте домой. {name}?',
  'city.greet.night.0': 'Поздно выйти. {name}.',
  'city.greet.night.1': 'Осторожнее с темнотой. {name}.',
  'city.greet.night.2': 'Все еще здесь, {name}?',
  'city.greet.morning.0.anon': 'Доброе утро, друг!',
  'city.greet.morning.1.anon': 'Доброе утро.',
  'city.greet.morning.2.anon': 'Ранно встаешь, друг?',
  'city.greet.afternoon.0.anon': 'Добрый день, друг.',
  'city.greet.afternoon.1.anon': 'Удачи вам!',
  'city.greet.afternoon.2.anon': 'Хорошо, что мы встретились.',
  'city.greet.evening.0.anon': 'Вечером, друг.',
  'city.greet.evening.1.anon': 'Добрый вечер!',
  'city.greet.evening.2.anon': 'Вышел из дома, друг?',
  'city.greet.night.0.anon': 'Поздно выйти, друг.',
  'city.greet.night.1.anon': 'Осторожнее с темнотой.',
  'city.greet.night.2.anon': 'Все еще здесь, друг?',
  'city.market.title': 'Рыночная доска',
  'city.market.shut': 'Сейчас ничего не выложено.',
  'city.market.later': 'Позже сегодня:',
  'city.market.am': '{n} утром',
  'city.market.pm': '{n} днем',
  'city.market.eve': '{n} в вечернее время',
  'city.garden.title': 'Садовые участки',
  'city.garden.tend': 'Посмотрите на сюжет.',
  'city.garden.tended': 'Вытащишь пару сорняков и поливаешь участок.',
  'city.garden.already': 'Ты уже сегодня занимался этим сюжетом.',
  'city.garden.tendedNote': 'сегодня',
  'city.garden.arrive': 'Сборник {crop} Вот они. {stage}.',
  'city.garden.crop.herbs': 'травы',
  'city.garden.crop.apples': 'яблочные деревья',
  'city.garden.crop.kitchen': 'Кухонные зеленые деревья',
  'city.garden.crop.cabbages': 'капусты и бобы',
  'city.garden.crop.wheat': 'пшеничные поля',
  'city.garden.stage.bare': 'Голые на зиму',
  'city.garden.stage.sown': 'свеже посеянные',
  'city.garden.stage.sprouting': 'разрастающийся',
  'city.garden.stage.growing': 'хорошо растут',
  'city.garden.stage.flowering': 'в цвете',
  'city.garden.stage.ripe': 'созревшие и готовые',
  'city.garden.stage.harvested': 'сбрасываемые за год',
  'city.fish.title': 'Рыбалка',
  'city.fish.cast': 'Положите линию .',
  'city.fish.go': 'Иди .',
  'city.fish.here': 'Хорошее место для рыбалки.',
  'city.fish.casting': 'Вы ждите в очереди.',
  'city.fish.caught': 'Что-то кусается. {fish}.',
  'city.fish.got.boot': 'Ты закручиваешь старую ботинку и бросаешь обратно.',
  'city.fish.got.weed': 'Только речной травой на этот раз.',
  'city.fish.got.nothing': 'Ничто не укусает, вода хранит свои секреты.',
  'city.fish.casts': '{n} бросает до сих пор',
  'city.fish.none': 'Рыбы лучше кусаются на рассвете и закате, а еще весной и осенью.',
  'city.fish.spot.bank': 'берег реки',
  'city.fish.spot.jetty': 'прокладка',
  'city.fish.spot.bridge': 'Мост мельницы',
  'city.fish.name.perch': 'лопатка',
  'city.fish.name.roach': 'Кака-какака',
  'city.fish.name.trout': 'форель',
  'city.fish.name.eel': 'ульга',
  'city.fish.name.pike': 'пик',
  'city.fish.name.carp': 'карп',
  'city.fish.name.minnow': 'Миноу',
  'city.fish.name.crayfish': 'раковина',
  'city.fish.name.boot': 'Старый ботинок',
  'city.fish.name.weed': 'речная трава',
  'city.fish.name.nothing': 'Ничего.',
  'city.lost.title': 'Потерянные и найденные',
  'city.lost.none': 'Городские люди бросают вещи на рынках, площади и других оживленных местах.',
  'city.lost.whose': 'принадлежит {name}',
  'city.lost.find': 'Найти {name}',
  'city.lost.spot': 'Здесь что-то лежит на земле: {thing}',
  'city.lost.pick': 'Взять . {thing}',
  'city.lost.picked': 'Ты отвечаешь . {thing}. Похоже , он принадлежит {name}.',
  'city.lost.give': 'Давать {thing} возвращаться к {name}',
  'city.lost.thanks': '{name} Радуется, что {thing} - Отойди.',
  'city.lost.thing.glove': 'потерянная перчатка',
  'city.lost.thing.keys': 'кольцо ключей',
  'city.lost.thing.locket': 'маленький медальон',
  'city.lost.thing.toy': 'деревянная игрушка',
  'city.lost.thing.scarf': 'шерсть из шерсти',
  'city.lost.thing.purse': 'пустая сумка',
  'city.lost.thing.spectacles': 'пара очков',
  'city.lost.thing.letter': 'свернутое письмо',
  'city.lost.thing.ribbon': 'волосная лента',
  'city.lost.thing.pipe': 'глиняная труба',
  'city.records.title': 'Городские записи',
  'city.records.peak': 'На сегодняшний день {time}, с {n} Городские люди.',
  'city.records.now': 'В этот час: {out} Выйти. {home} дома.',
  'city.records.busiest': 'Наиболее оживленный квартал: {district}.',
  'city.records.outTitle': 'Горожане выходят, по часам.',
  'city.records.seenTitle': 'Люди, которых ты видел вокруг себя, по часам',
  'city.a11y.title': 'Доступность',
  'city.a11y.text': 'Размер текста',
  'city.a11y.size1': 'Нормально',
  'city.a11y.size125': 'Большой',
  'city.a11y.size15': 'Самый большой',
  'city.a11y.stillOff': 'Сокращение движения',
  'city.a11y.stillOn': 'Сокращение ходатайства',
  'city.a11y.contrastOff': 'Высокий контраст',
  'city.a11y.contrastOn': 'Высокий контраст на',
  'city.tour.welcome.title': 'Добро пожаловать {city}',
  'city.tour.welcome.body': 'Этот город живет в своем собственном времени. Люди просыпаются, работают, едят и спят независимо от того, смотрите вы или нет.',
  'city.tour.walk.title': 'Прогулка',
  'city.tour.walk.body': 'Нажмите на любую открытую землю, чтобы пройти туда, и ваш робот найдет свой собственный путь вокруг стен и через двери.',
  'city.tour.talk.title': 'Говорит',
  'city.tour.talk.body': 'Нажмите на человека, чтобы увидеть его имя и подойти к нему.',
  'city.tour.menu.title': 'Посмотрим ближе.',
  'city.tour.menu.body': 'На компьютере направо нажмите что-либо, чтобы увидеть, что вы можете сделать там, например, прочитать знак, сесть или взять комнату.',
  'city.tour.map.title': 'Минимальная карта',
  'city.tour.map.body': 'На маленькой карте в углу показываются дороги, районы и люди рядом с вами.',
  'city.tour.panel.title': 'Твоя панель',
  'city.tour.panel.body': 'На боковой панели указаны люди, которые находятся рядом, места, которые вы обнаружили, ваши задания, ваш дневник и многое другое.',
  'city.tour.keys.title': 'Перемещение',
  'city.tour.keys.body': 'Кнопка клавиатуры показывает каждый шаг, который знает ваш робот.',
  'city.tour.done.title': 'Это всё .',
  'city.tour.done.body': 'Наслаждайтесь . {city}. Вы можете сделать этот тур снова с боковой панели.',
  'city.tour.step': '{n} из {total}',
  'city.tour.next': 'Следующий',
  'city.tour.back': 'Вернуться',
  'city.tour.skip': 'Пропустите экскурсию .',
  'city.tour.finish': 'Начните исследовать',
  'city.tour.again': 'Проверь город снова .',
  'city.found.title': 'Открытые места',
  'city.found.count': '{n} из {total}',
  'city.found.none': 'Пойдем туда, чтобы добавить его сюда.',
  'city.found.new': 'Открыто {place}',
  'city.board.open': 'Читайте публичную доску записей',
  'city.board.hint': 'Записки, оставленные здесь другими путешественниками.',
  'city.board.placeholder': 'Напиши короткую записку для других',
  'city.board.pin': 'Запиши записку.',
  'city.board.loading': 'Читая доску...',
  'city.board.by': '{name}, {when}',
  'city.board.remove': 'Запиши записку .',
  'city.board.err.signin': 'Запишись, чтобы записать записку.',
  'city.board.err.soon': 'Подожди немного, прежде чем заложить еще одну записку.',
  'city.board.err.bad': 'Примечания должны быть простым текстом до 200 символов, без ссылок.',
  'city.board.err.down': 'Сборную сейчас не могут связаться.',
  'city.room.rent': 'Найдите комнату в {place}',
  'city.room.move': 'Перемести свою комнату в {place}',
  'city.room.yours': 'Твоя комната в {place}',
  'city.room.decorate': 'Поставь здесь что-нибудь.',
  'city.room.remove': 'Снимите {thing}',
  'city.room.leave': 'Отдайте свою комнату.',
  'city.room.full': 'В твоей комнате больше нет места.',
  'city.room.pickTitle': 'Оформляй свою комнату',
  'city.room.pickHint': 'Выберите что-нибудь, чтобы установить на этом месте, оно останется в вашей комнате на этом устройстве.',
  'city.room.kind.rug': 'Вытяжённый ковер',
  'city.room.kind.candle': 'Свеча .',
  'city.room.kind.flowers': 'Глотка с цветами',
  'city.room.kind.painting': 'Картина',
  'city.room.kind.plant': 'Растение в горшке',
  'city.room.kind.chest': 'Маленькая грудь.',
  'city.room.kind.lantern': 'Фонарик',
  'city.room.kind.books': 'Несколько книг .',
  'city.busk.lute': '{name} поднимает яркую мелодию вблизи',
  'city.busk.fiddle': '{name} избивает живой ролик рядом',
  'city.busk.pipe': '{name} играет медленный воздух вблизи',
  'city.busk.drum': '{name} выступает на танце рядом',
  'city.tail.label': 'Следующие {name}',
  'city.tail.title': 'Задница {name} в течение дня',
  'city.tail.now': 'Теперь: {activity} на {place}',
  'city.tail.unknown': 'Их планы на данный момент неизвестны.',
  'city.tail.next': 'Следующее: {place} на {time}, в {h} h {m} минимум',
  'city.tail.trail': 'Отслеживаем: {places}',
  'city.tail.stop': 'Перестань следовать .',
  'city.pins.add': 'Добавить пинку',
  'city.pins.tapMap': 'Нажмите на карту , чтобы поместить пинку .',
  'city.pins.walk': 'Иди к этой коробке .',
  'city.pins.note': 'Запишите на {x}, {y}. Добавьте записку',
  'city.pins.noteLabel': 'Примечание кнопки',
  'city.pins.remove': 'Убрать этот штифт',
  'city.pins.here': 'Напиши это место на карте.',
  'city.compass.north': 'Северо',
  'city.compass.at': 'x {x}, y {y}, этаж {floor}',
  'city.door.prop': 'Открой дверь.',
  'city.door.close': 'Пусть дверь закроется',
  'city.door.unlock': 'Открой дверь.',
  'city.door.lock': 'Закрой дверь.',
  'city.books.browse': 'Просмотреть полки',
  'city.books.shelf': 'Покрытие в {place}',
  'city.books.book': 'Книга',
  'city.books.scroll': 'Скрутка',
  'city.books.prev': 'Предыдущие',
  'city.books.back': 'Возвращайся на полку .',
  'city.books.next': 'Следующий',
  'city.books.page': 'Страница {n} из {of}',
  'city.sign.readSign': 'Прочитай знак.',
  'city.sign.readPlaque': 'Читайте табличку .',
  'city.sign.sign': 'Окрашенный знак',
  'city.sign.plaque': 'Плата у двери',
  'city.district.entering': 'Теперь мы входим .',
  'city.district.riverside': 'На берегу реки и на низких рынках',
  'city.district.sunwalk': 'Солнечная прогулка',
  'city.district.lanes': 'Лейны',
  'city.district.monastery': 'Монастырь',
  'city.district.castle': 'Замок',
  'city.district.drains': 'Старые канализации',
  'city.district.farmlands': 'Сельскохозяйственные угодья',
  'city.photo.enter': 'Фоторежим',
  'city.photo.hint': 'Фоторежим: перетащи, чтобы посмотреть вокруг, сделай снимок экрана, чтобы сохранить его.',
  'city.photo.leave': 'Оставьте режим фотографии',
  'city.building.who': 'Кто живет и работает в {place}',
  'city.building.live': 'Живет здесь.',
  'city.building.work': 'Работает здесь.',
  'city.building.now': 'Внутри .',
  'city.building.rooms': 'Принимает {list}.',
  'city.inspect.about': 'О {name}',
  'city.inspect.close': 'Ближе .',
  'city.inspect.unknown': 'Никто не может рассказать тебе многое о {name}.',
  'city.inspect.home': 'Дом',
  'city.inspect.work': 'Работа',
  'city.inspect.none': 'Никто не знает',
  'city.inspect.today': 'Сегодня',
  'city.inspect.row': '{what}, {place}',
  'city.inspect.follow': 'Следуйте {name} в течение дня',
  'city.overlay.label': 'Картографические перекрытия',
  'city.overlay.crowd': 'Толпы',
  'city.overlay.light': 'Свет',
  'city.overlay.noise': 'Шум',
  'city.bar.pop': '{n} Жить здесь',
  'city.bar.out': '{n} Выходи .',
  'city.bar.season.spring': 'Весна',
  'city.bar.season.summer': 'Лето',
  'city.bar.season.autumn': 'Осень',
  'city.bar.season.winter': 'Зима',
  'city.notebook.title': 'Слышал и узнал',
  'city.notebook.all': 'Все',
  'city.notebook.heard': 'Я слышал .',
  'city.notebook.learned': 'Учился',
  'city.notebook.search': 'Проверь записки .',
  'city.notebook.none': 'Выслушайте на улице и поговорите с людьми.',
  'city.ask.title': 'Спросите вокруг.',
  'city.ask.pick': 'Кого вы ищете?',
  'city.ask.ask': 'Спросите',
  'city.ask.passerby': 'Прохожий',
  'city.ask.nobody': 'Нет никого близкого, чтобы спросить.',
  'city.ask.unseen': '{asker} не видел {who} О сегодняшнем дне.',
  'city.ask.here': '{asker} говорит {who} близок. {place}.',
  'city.ask.go': 'Иди в {who}',
  'city.weather.clear': 'Чистое небо',
  'city.weather.cloudy.light': 'Несколько облаков .',
  'city.weather.cloudy.heavy': 'Серая и облачная',
  'city.weather.rain.light': 'Легкий дождь',
  'city.weather.rain.heavy': 'Сильный дождь',
  'city.weather.fog.light': 'Утренняя туманность',
  'city.weather.fog.heavy': 'Толстая туманность',
  'city.weather.snow.light': 'Легкий снег',
  'city.weather.snow.heavy': 'Сильный снег',
  'city.lamplighter.name': 'Светодильник',
  'city.lamplighter.lighting': 'освещение уличных светильников',
  'city.lamplighter.dousing': 'выключать уличные лампы',
  'city.hourglass.title': 'Песчаные часы',
  'city.hourglass.stop': 'Прекратите день.',
  'city.hourglass.paused': 'День остановился.',
  'city.hourglass.resume': 'Продолжайте.',
  'city.seat.bench': 'скамейка',
  'city.seat.chair': 'стул',
  'city.seat.sit': 'Сядьте на {what}',
  'city.inside.crate': 'коробка',
  'city.inside.barrel': 'баррель',
  'city.inside.title': 'Внутри {what}',
  'city.inside.look': 'Посмотрите в {what}',
  'city.inside.holds': 'Это {fill}: {list}.',
  'city.factions.title': 'Стоя в городе',
  'city.factions.wary': 'Остерегайтесь',
  'city.factions.unknown': 'Неизвестно',
  'city.factions.noticed': 'Замечено',
  'city.factions.trusted': 'Доверенный',
  'city.factions.honored': 'Уважаемый',
  'city.factions.done': 'Задачи выполнены: {n}.',
  'city.mail.title': 'Письма',
  'city.mail.none': 'Пока нет писем.',
  'city.mail.from': 'От: {name}',
  'city.mail.waiting': 'Ждём ответа от {names}.',
  'city.mail.nobody': 'Помоги кому-то с заданием, и ты можешь им написать.',
  'city.mail.write': 'Напиши письмо .',
  'city.mail.to': 'К кому',
  'city.mail.subject': 'Предмет',
  'city.mail.body': 'Ваше письмо .',
  'city.mail.send': 'Пошлите .',
  'city.mail.untitled': 'Несколько строк .',
  'city.moth.title': 'Поднос Мотели',
  'city.moth.trade': 'Сделай мне услугу.',
  'city.moth.yours': 'Теперь твоя.',
  'city.spy.title': 'Тихая работа',
  'city.cut.skip': 'Скип .',
  'city.party.title': 'Играйте вместе .',
  'city.party.blurb': 'Начните вечеринку и делитесь ее кодом с друзьями.',
  'city.party.start': 'Начните вечеринку .',
  'city.party.codeLabel': 'Код партии',
  'city.party.join': 'Присоединяйтесь',
  'city.party.bad': 'Партийный код состоит из четырех-восемь букв или цифр.',
  'city.party.code': 'Ваш партийный код: {code}. Поделитесь этим с друзьями, чтобы они могли присоединиться.',
  'city.party.alone': 'Никто из вашей партии не в городе сейчас.',
  'city.party.here': 'прямо рядом с тобой',
  'city.party.away': '{n} шаги {dir}',
  'city.party.floor': '(поверх {n})',
  'city.party.go': 'Иди в',
  'city.party.leave': 'Отойди от вечеринки.',
  'city.party.dir.east': 'Восток',
  'city.party.dir.south-east': 'юго-восток',
  'city.party.dir.south': 'Южный',
  'city.party.dir.south-west': 'юго-запад',
  'city.party.dir.west': 'Запад',
  'city.party.dir.north-west': 'Северо-запад',
  'city.party.dir.north': 'Север',
  'city.party.dir.north-east': 'Северо-восток',
  'city.print.title': 'Напечатать здание',
  'city.print.here': '{name}: {w} по {d} ячейки, этажи: {n}. Сохрани его в качестве СТЛ для 3D-принтера.',
  'city.print.none': 'Стоять в здании или рядом с ним, чтобы сохранить его в качестве STL для 3D-принтера.',
  'city.print.model': 'Сбережение STL, масштаб модели (5 мм за ячейку)',
  'city.print.tabletop': 'Сохранить STL, шкалы на столе (1 дюйм в ячейку)',
  'city.print.note': 'Стены, этажи, двери, лестницы и окна, как их рисует город, на основной доске, так что он печатается в одном куске.',
  'city.print.models': 'Фигуры и реквизиты, готовые к печати:',
  'city.print.busy': 'Подготавливаю...',
  'city.print.model.figure': 'Фигура Walker, 28 мм на базе 25 мм',
  'city.print.model.fountain': 'Фонтан, дюйм в дюйм',
  'city.print.model.castle-wall': 'Секция стены замка, длина 3 дюйма',
  'city.editor.stl': 'Сохранить STL',
  'city.editor.title': 'Редактор карты города',
  'city.editor.blurb': 'Нарисуйте карту города по этажу: стены, улицы, двери, вода, лестницы и названные места.',
  'city.editor.name': 'Название карты',
  'city.editor.tools': 'Инструменты',
  'city.editor.tool.pen': 'Пероль',
  'city.editor.tool.rect': 'Блок',
  'city.editor.tool.room': 'Комната',
  'city.editor.tool.fill': 'Наполните',
  'city.editor.tool.spawn': 'Начальная точка',
  'city.editor.tiles': 'Земля',
  'city.editor.letter': 'Письмо',
  'city.editor.placeName': 'Название места',
  'city.editor.addPlace': 'Добавить место',
  'city.editor.placeBad': 'Место нуждается в одной букве и названии.',
  'city.editor.floors': 'Полы',
  'city.editor.addFloor': 'Добавить пол',
  'city.editor.map': 'Карта',
  'city.editor.width': 'Ширина',
  'city.editor.height': 'Высота',
  'city.editor.new': 'Новая карта',
  'city.editor.undo': 'Устранение',
  'city.editor.export': 'Экспорт',
  'city.editor.import': 'Импорт',
  'city.editor.loaded': 'Карта загружена.',
  'city.editor.zoom': 'Звездие',
  'city.editor.check': 'Проверка',
  'city.editor.ok': 'Чисто читается. {walk} открытые клетки, {reach} доступны с точки начала.',
  'city.editor.placeSpots': '{name}: {n} клетки',
  'city.editor.canvas': 'Картовая полотенца',
  'city.spy.take': 'Возьми .',
  'city.spy.again': 'Попробуй еще раз.',
  'city.spy.drop': 'Оставь это.',
  'city.spy.progress': '{n} процентов там.',
  'city.spy.carrying': 'У тебя есть записка.',
  'city.spy.underway': 'В пути.',
  'city.spy.done': 'Сделано.',
  'city.spy.failed': 'В прошлый раз всё пошло не так.',
  'city.menu.look': 'Посмотрите . {thing}',
  'city.menu.street': 'Улица',
  'city.menu.wall': 'Стену',
  'city.continue': 'Продолжайте',
  'city.goodbye': 'До свидания .',
  'city.board.title': 'Наградная доска',
  'city.arrive.rooftops': 'Вы поднимаетесь на крышу, а под вами открываются полосы, а доски между домами кричат под ногами.',
  'city.arrive.museumRoof': 'Вы подтягиваете себя на крышу музея, а площадь под вами, как игровая доска.',
  'city.crier.title': 'Лист кричащего',
  'city.crier.today': 'Сегодня {name}.',
  'city.crier.tomorrow': '{name} Это завтра.',
  'city.crier.coming': '{name} в {n} Дни.',
  'city.crier.stalls': 'На стойках на рассвете:',
  'city.crier.notices': '{n} Уведомления на доске наград.',
  'city.crier.talk': 'Говоря о городе:',
  'city.crier.now': 'Что происходит в городе сейчас:',
  'city.board.empty': 'Сегодня ничего не зафиксировано.',
  'city.board.posted': 'Опубликовано {name}.',
  'city.board.postedAt': 'Опубликовано {name}, сейчас в {place}.',
  'city.board.days': '{n} Осталось несколько дней.',
  'city.board.find': 'Найди их.',
  'city.topics.ask': '{word}?',
  'city.talkWith': 'Я разговариваю с {name}',
  'city.journal': 'Журнал',
  'city.journalNone': 'Пока ничего не написано.',
  'city.quests': 'Рыбы и нитки',
  'city.questNone': 'Пока нет, разговаривай с людьми.',
  'city.rest': 'Отдых {n} минуты',
  'city.saves.title': 'Спасенные игры',
  'city.saves.slot': 'Слот {n}: {day} {time}, {place}',
  'city.saves.empty': 'Раздел {n}: пустой',
  'city.saves.save': 'Сохрани здесь',
  'city.saves.load': 'Нагрузка',
  'city.saves.sure': 'Нажмите еще раз , чтобы подтвердить',
  'city.saves.hint': 'Сбережение держит весь город в своем положении: где ты находишься, час, люди, задания и груди.',
  'city.restHint': 'Пройди время, ты можешь отдохнуть всего за час.',
  'city.bed.ask': 'Поспать . {bed}?',
  'city.bed.night': 'Проходит восемь часов, пока ты спишь, и ты отдыхаешь по правилам своей игровой системы.',
  'city.bed.sleep': 'Сон',
  'city.bed.notNow': 'Не сейчас.',
  'city.bed.tired': 'Ты еще не устал, ты можешь снова спать через несколько минут. {n} Часы.',
  'city.bed.asleep': 'Ночь проходит...',
  'city.bed.offer': 'Поспи здесь.',
  'city.vitals': 'Здоровье',
  'city.bed.woke': 'Ты спишь . {bed} и проснуться в {time}. {change}',
  'city.bed.change': '{label}: {before} к {after}.',
  'city.bed.noRest': 'Сборник {system} Правила не дают восстановления для отдыха, так что ничего не исцеляет.',
  'city.bed.beds': 'Кровать',
  'city.bed.demoRules': 'Правила испытания кровати: {system}. Добавьте "правила" к адресу, чтобы попробовать другую.',
  'city.messages': 'Примечания',
  'city.rules': 'Игровая система',
  'city.rulesNarrative': 'Никаких правил: город как история. Выберите систему, чтобы видеть всех в его числах.',
  'city.statsFor': 'Цифры для',
  'city.sparTitle': 'Упражнения',
  'city.sparA': 'Первый боец',
  'city.sparB': 'Второй истребитель',
  'city.sparVs': 'против',
  'city.sparRun': 'Сражайтесь',
  'city.sparNote': 'Демонстрация в этой системе, никто в городе не пострадал.',
  'city.sparRound': 'Круглый {n}.',
  'city.zoomIn': 'Займите в зоопарк .',
  'city.pivot.left': 'Повернуть вид влево',
  'city.pivot.right': 'Повернуть вид вправо',
  'city.pivot.north': 'Повернуться на север',
  'city.zoomOut': 'Займите вверх .',
  'city.centre': 'Стремись ко мне.',
  'city.followOn': 'Продолжайте',
  'city.followOff': 'Продолжайте .',
  'city.followOnHint': 'Камера следит за тобой.',
  'city.followOffHint': 'Нажми на меня, чтобы вернуться к себе.',
  'city.minimapShow': 'Показать карту',
  'city.minimapHide': 'Скрыть карту',
  'city.minimapOpen': 'Нажмите, чтобы открыть его больше.',
  'city.minimapWalk': 'Нажмите на городскую карту.',
  'city.minimapSmall': 'Уменьшить карту',
  'city.minimapHint': 'Нажмите , чтобы пройти туда .',
  'city.chatter.morning.1.a': 'Свежий хлеб в угловых печах, если спешите.',
  'city.chatter.morning.1.b': 'Я почувствовал запах две улицы назад.',
  'city.chatter.morning.2.a': 'Ты рано встала.',
  'city.chatter.morning.2.b': 'Звонки разбудили меня, как всегда.',
  'city.chatter.morning.3.a': 'Коляски вошли через ворота?',
  'city.chatter.morning.3.b': 'Трое из них, а один потерял колесо на мосту.',
  'city.chatter.morning.4.a': 'Сегодня утром холодно.',
  'city.chatter.morning.4.b': 'Речной туман сгорит к полудня.',
  'city.chatter.morning.5.a': 'Куда ты едешь?',
  'city.chatter.morning.5.b': 'Рынок, до того, как хорошие яблоки исчезнут.',
  'city.chatter.afternoon.1.a': 'Загруженный день в конторах.',
  'city.chatter.afternoon.1.b': 'Слишком занят, ноги отступили от меня.',
  'city.chatter.afternoon.2.a': 'Ты сегодня видел таннер?',
  'city.chatter.afternoon.2.b': 'Он спустился в воду час назад.',
  'city.chatter.afternoon.3.a': 'Солнце сегодня мило.',
  'city.chatter.afternoon.3.b': 'Наступает дождь, я чувствую его в коленях.',
  'city.chatter.afternoon.4.a': 'Что хотел рыбопродавец для зонтов?',
  'city.chatter.afternoon.4.b': 'Слишком много.',
  'city.chatter.afternoon.5.a': 'Это новая тележка?',
  'city.chatter.afternoon.5.b': 'Колеса все еще кричат как старые.',
  'city.chatter.evening.1.a': 'Ты уже уезжаешь домой?',
  'city.chatter.evening.1.b': 'Ужин не будет готовиться сам.',
  'city.chatter.evening.2.a': 'Лампы зажигаются.',
  'city.chatter.evening.2.b': 'Тогда я опять опоздал.',
  'city.chatter.evening.3.a': 'Ты будешь в таверне сегодня вечером?',
  'city.chatter.evening.3.b': 'Если моя жена позволит, да.',
  'city.chatter.evening.4.a': 'Длинный день.',
  'city.chatter.evening.4.b': 'Все они, в это время года.',
  'city.chatter.evening.5.a': 'Закройте свои окна сегодня вечером.',
  'city.chatter.evening.5.b': 'Я всегда так делаю, но ветер все равно их держит.',
  'city.chatter.night.1.a': 'Кто туда едет?',
  'city.chatter.night.1.b': 'Опустите фонарик.',
  'city.chatter.night.2.a': 'Ты должен спать.',
  'city.chatter.night.2.b': 'И тебе тоже, друг.',
  'city.chatter.night.3.a': 'Ты что-то слышал у воды?',
  'city.chatter.night.3.b': 'Кошки, это всегда кошки.',
  'city.chatter.night.4.a': 'Тихая ночь.',
  'city.chatter.night.4.b': 'Давай так и останется.',
  'city.chatter.any.1.a': 'Вы слышали новости?',
  'city.chatter.any.1.b': 'Какие новости?',
  'city.chatter.any.2.a': 'Удачный день.',
  'city.chatter.any.2.b': 'И тебе.',
  'city.chatter.any.3.a': 'Мой кузен клянется, что старая башня обнажена.',
  'city.chatter.any.3.b': 'Твой кузен много клянется.',
  'city.chatter.any.4.a': 'Цены продолжают расти.',
  'city.chatter.any.4.b': 'И моя зарплата остается неподвижной.',
  'city.chatter.any.5.a': 'Осторожнее с прудом.',
  'city.chatter.any.5.b': 'Слишком поздно.',
  'city.chatter.any.6.a': 'Это тот незнакомец, о котором все говорят?',
  'city.chatter.any.6.b': 'Не смотри, это грубо.',
  'city.chatter.any.7.a': 'Как твоя мать?',
  'city.chatter.any.7.b': 'Она снова стала меня оскорблять.',
  'city.chatter.any.8.a': 'Я должен тебе выпить, не так ли?',
  'city.chatter.any.8.b': 'Два, по моему подсчету.',
  'city.inventory.title': 'Твоя упаковка',
  'city.inventory.subtitle': 'Montkelian кошелек',
  'city.inventory.close': 'Закройте пачку .',
  'city.inventory.tabs': 'Разделы упаковки',
  'city.inventory.tab.inventory': 'Инвентарь',
  'city.inventory.tab.journal': 'Журнал',
  'city.inventory.tab.map': 'Карта',
  'city.inventory.empty': 'Все, что вы найдете в путешествиях, будет храниться в этих карманах.',
  'city.inventory.slots': 'Яблоки',
  'city.inventory.slotEmpty': 'Яблочный {n}, пустой',
  'city.inventory.slot.headgear': 'Заглавная одежда',
  'city.inventory.slot.helmet': 'Шлем',
  'city.inventory.slot.hat': 'Шапка',
  'city.inventory.slot.hood': 'Капуста',
  'city.inventory.slot.amulet': 'Амулет',
  'city.inventory.slot.cloak': 'Плетень',
  'city.inventory.slot.tabard': 'Табард',
  'city.inventory.slot.pelt': 'Кожа',
  'city.inventory.slot.armor': 'Оружие',
  'city.inventory.slot.plate': 'Площадь',
  'city.inventory.slot.robe': 'Рубашка',
  'city.inventory.slot.jerkin': '- Я не знаю.',
  'city.inventory.slot.hide': 'Скрыться .',
  'city.inventory.slot.girdle': 'Гирдль',
  'city.inventory.slot.belt': 'Пояс',
  'city.inventory.slot.bracers': 'Брейкеры',
  'city.inventory.slot.gloves': 'Перчатки',
  'city.inventory.slot.mainHand': 'Главная рука',
  'city.inventory.slot.offHand': 'Не под рукой',
  'city.inventory.slot.twoHand': 'Обе руки.',
  'city.inventory.slot.sword': 'Меч',
  'city.inventory.slot.shield': 'Щит',
  'city.inventory.slot.staff': 'Персонал',
  'city.inventory.slot.focus': 'Сосредоточьтесь',
  'city.inventory.slot.ring': 'Кольцо',
  'city.inventory.slot.leggings': 'Леггинсы',
  'city.inventory.slot.greaves': 'Грейв',
  'city.inventory.slot.boots': 'Бутылки',
  'city.inventory.item.sword': 'Меч',
  'city.inventory.item.shield': 'Щит',
  'city.inventory.item.knife': 'Нож',
  'city.inventory.item.axe': 'Осколка',
  'city.inventory.item.tabard': 'Табард',
  'city.inventory.item.cape': 'Кабель',
  'city.inventory.item.ring': 'Кольцо',
  'city.inventory.class.default': 'путешественник',
  'city.inventory.class.fighter': 'боец',
  'city.inventory.class.paladin': 'Паладин',
  'city.inventory.class.berserker': 'Берсеркер',
  'city.inventory.class.wizard': 'волшебник',
  'city.inventory.class.rogue': 'нечестивый',
  'city.inventory.slotFree': 'Пустое',
  'city.inventory.gear': 'Что ты носишь',
  'city.inventory.view': 'Показать',
  'city.inventory.viewGear': 'Изготовленный',
  'city.inventory.viewPockets': 'Яблоки',
  'city.inventory.avatarHint': 'Выберите другой аватар из меню под "Аватар".',
  'city.inventory.soon.journal': 'Ваш дневник пока пустой.',
  'city.inventory.soon.map': 'Ваша складанная карта будет храниться здесь, отмечена местами, где вы были.',
  'city.inventory.hint': 'Нажмите на себя , чтобы открыть упаковку .',
  'city.avatar': 'Аватар',
  'city.avatarLabel': 'Выберите свой аватар',
  'city.avatar.robot': 'Робот',
  'city.avatar.nycanthea': 'Nycanthea',
  'city.avatar.paladin': 'Паладин',
  'city.avatarCloth': 'Покрытие',
  'city.avatarClothHint': 'Ковры и таборы колеблются , когда ты движишься .',
  'city.soundOn': 'Включи звук',
  'city.soundOff': 'Выключить звук',
  'city.musicOn': 'Играйте музыку',
  'city.musicOff': 'Прекратите музыку .',
  'city.walkSpeed': 'Скорость',
  'city.walkSpeedLabel': 'Скорость ходьбы',
  'city.walkSpeedValue': '{n}x',
  'city.me': 'Я',
  'city.quality': 'Качество',
  'city.qualityAuto': 'Автомобильный ({tier})',
  'city.tier.low': 'Низкий',
  'city.tier.medium': 'Средний',
  'city.tier.high': 'Высокая',
  'city.robot.keys': 'Ключи для роботов',
  'city.robot.title': 'Ключи для роботов',
  'city.robot.intro': 'Нажмите на кнопку или нажмите здесь, и ваш робот выставит его для всех, кто находится рядом.',
  'city.robot.close': 'Ближе .',
  'city.robot.jumpNote': 'Нажмите Space снова, пока вы в воздухе, чтобы сделать двойной прыжок.',
  'city.robot.spellNote': 'В режиме заклинания 1, 2 и 3 бросаются вместо атаки.',
  'city.robot.climbNote': 'Вы можете подняться по лестнице, лестнице или канализации, которые ближе всего к вам.',
  'city.robot.walkNote': 'В, А, С и Д ходят на север, запад, юг и восток шаг за шагом.',
  'city.robot.walk.north': 'Пойдем на север.',
  'city.robot.walk.west': 'Ходьба на запад',
  'city.robot.walk.south': 'Прогуляйтесь на юг',
  'city.robot.walk.east': 'Идите на восток.',
  'city.stairs.label': 'Поднимитесь по лестнице .',
  'city.stairs.up': 'Вверх.',
  'city.stairs.down': 'Вниз.',
  'city.stairs.goUp': 'Поднимитесь на пол.',
  'city.stairs.goDown': 'Спустись на пол .',
  'city.robot.toggleNote': 'В режиме оружия, заклинания, подсказки, танцы и падение оставайтесь на них, пока вы не нажмете их снова.',
  'city.robot.typing': 'Ключи ничего не делают, пока ты пишешь в ящике.',
  'city.robot.inSpell': 'Режим заклинания: {act}',
  'city.robot.otherwise': 'В противном случае: {act}',
  'city.robot.pad': 'Действия',
  'city.robot.padShow': 'Показать панель действий',
  'city.robot.padHide': 'Скрыть планшет действия',
  'city.robot.padTouch': '(для сенсорных экранов)',
  'city.robot.noLadder': 'Никаких лестниц или лестницы рядом.',
  'city.robot.act.jump': 'Спрыгивай.',
  'city.robot.act.double-jump': 'Двойной прыжок',
  'city.robot.act.dodge': 'Избегайте .',
  'city.robot.act.block': 'Блокировать или защищать',
  'city.robot.act.parry': 'Парри',
  'city.robot.act.weapon-mode': 'Режим оружия',
  'city.robot.act.spell-mode': 'Режим заклинания',
  'city.robot.act.slash': 'Слайд',
  'city.robot.act.thrust': 'Движение',
  'city.robot.act.flurry': 'Спустя время',
  'city.robot.act.cast': 'Кастинг',
  'city.robot.act.cast-spell': 'Заклинание',
  'city.robot.act.megacast': 'Мегакаст',
  'city.robot.act.duck': 'Утка.',
  'city.robot.act.sneak': 'Ухищрение',
  'city.robot.act.sing': 'Пойте .',
  'city.robot.act.dance': 'Танцуй',
  'city.robot.act.barf': 'Оригинальное название',
  'city.robot.act.fall': 'Пасть или встать',
  'city.robot.act.climb-up': 'Поднимитесь.',
  'city.robot.act.climb-down': 'Поднимитесь .',
  'city.robot.act.hurt': 'Сделай удар .',
  'city.robot.act.kneel': 'На колени и стоять',
  'city.robot.act.bow': 'Поклониться',
  'city.robot.act.cheer': 'Приветствуем победу',
  'city.panelShow': 'Показательная панель',
  'city.phone.menu': 'Меню',
  'city.phone.close': 'Закрыть меню',
  'city.phone.view': 'Карта',
  'city.phone.sound': 'Звук и темп',
  'city.phone.people': 'Найди кого-нибудь .',
  'city.phone.more': 'Все остальное .',
  'city.phone.hint': 'Нажмите на землю, чтобы ходить, нажмите на человека, чтобы поговорить.',
  'city.phone.gotIt': 'Я поняла.',
  'city.panelHide': 'Скрыть панель',
  'city.canvasLabel3d': 'Карта {city} Сверху можно посмотреть под углом. Сверните, чтобы посмотреть вокруг, нажмите или прокрутите, чтобы увеличить, нажмете, чтобы ходить или говорить.',
  'city.dock.label': 'Люди, которых нужно найти',
  'city.dock.go': 'Прогуляйтесь . {name}',
  'city.dock.walking': 'Ходить к {name}',
  'city.dock.toPlace': 'Ходить к {name} на {place}',
  'city.dock.cancel': 'Нажмите на землю , чтобы остановиться .',
  'city.rigDebug.open': 'Дебагировать движение {name}',
  'city.rigDebug.title': 'Отладка устройства: {name}',
  'city.rigDebug.close': 'Ближе .',
  'city.rigDebug.move': 'Перемещайся',
  'city.rigDebug.facing': 'Впереди',
  'city.rigDebug.allMoves': 'Все движения',
  'city.rigDebug.allFacings': 'Все стороны',
  'city.rigDebug.cycling': 'Велосипедные, {s} каждый',
  'city.rigDebug.play': 'Играть',
  'city.rigDebug.pause': 'Пауза',
  'city.rigDebug.back': 'Сделайте шаг назад.',
  'city.rigDebug.forward': 'Шаг вперёд один кадр',
  'city.rigDebug.speed': 'Скорость',
  'city.rigDebug.hint': 'Пауза, шаг за шагом, нажмите на дверь или нажмите Escape, чтобы закрыть.',
  'city.rigDebug.anim.idle': 'Недействительный',
  'city.rigDebug.anim.walk': 'Прогуляйтесь',
  'city.rigDebug.debug': 'Отладка',
  'city.rigDebug.viewLabel': 'Вид',
  'city.rigDebug.view.2d': '2D',
  'city.rigDebug.view.iso': 'Изометрические',
  'city.rigDebug.view.3d': '3D',
  'city.rigDebug.facingIs': 'на лице {dir}',
  'city.rigDebug.cell': 'строка {row}, рамка {col}',
  'city.rigDebug.loading': 'загрузка',
  'city.rigDebug.clip': 'Клип',
  'city.rigDebug.allClips': 'Все клипы',
  'city.rigDebug.noClips': 'Никаких клипов',
  'city.rigDebug.layers': 'Показать',
  'city.rigDebug.show.model': 'Модель',
  'city.rigDebug.show.bones': 'Кости',
  'city.rigDebug.show.pieces': 'Части',
  'city.rigDebug.boneCount': '{n} кости',
  'city.rigDebug.no3d': '3D-видео не может запускаться на этом экране.',
  'city.rigDebug.hint3d': 'Перетащи, чтобы повернуть камеру, паузу, шаг за шагом, нажмите на окно или нажмите Escape, чтобы закрыть.',
  'city.rigDebug.standIn': '{name} показано на {body} тело здесь, пока ее собственное не будет готово.',
  'city.rigDebug.archive': 'Архивы',
  'city.rigDebug.archivePose': 'Позовый просмотр: посмотрите, как {name} движется',
  'city.pose.open': 'Посмотрим , как . {name} движения',
  'city.pose.robot': 'Ты (робот-заместитель)',
  'city.pose.you': 'Ты ...',
  'city.pose.see': 'Посмотрите, как они движутся.',
  'city.pose.youTitle': 'Как ты двигаешься',
  'city.pose.openYou': 'Посмотри, как ты движишься.',
  'city.pose.title': 'Как? {name} движения',
  'city.pose.allTitle': 'Все позы',
  'city.pose.all': 'Покажите все позы',
  'city.pose.one': 'Просто... {name}',
  'city.pose.close': 'Ближе .',
  'city.pose.hint': 'Нажмите снаружи , чтобы закрыть .',
  'city.pose.loading': 'Загрузка',
  'city.pose.anim.idle': 'Недействительный',
  'city.pose.anim.walk': 'Прогуляйтесь',
  'city.pose.anim.talk': 'Поговори .',
  'city.pose.anim.sit': 'Сядь.',
  'city.pose.anim.run': 'Беги .',
  'city.pose.drag': 'Сдвинуть и повернуть',
  'city.pose.gait': 'Движение',
  'city.pose.model': '{name} в 3D',
  'city.pose.dir.SW': 'на юго-запад',
  'city.pose.dir.SE': 'направленный на юго-восток',
  'city.pose.dir.NE': 'направленный на северо-восток',
  'city.pose.dir.NW': 'направленный на северо-запад',
  'city.demoLink': 'Откройте демо-рендер',
  'city.demoTitle': 'Демонстрация выдачи',
  'city.demoNote': 'Местный просмотр 3D-города с хозяевами, ничего здесь не говорит с сервером игры.',
  'city.demoTime': 'Время дня',
  'city.demoSeason': 'Сезон',
  'city.demoPlay': 'Запустите часы .',
  'city.demoPause': 'Останови часы .',
  'city.demoTower': 'Испытательная башня',
  'city.demoTowerNote': 'Внутри вы вырезаны этажи над вами, и все, что вы не можете видеть, выделено в серое.',
  'city.demoGoTower': 'Прогуляйтесь к башне .',
  'city.demoFloor': 'Поверх: {floor}',
  'city.demoFloor0': 'Земля',
  'city.demoFloor1': 'Второй',
  'city.demoFloor2': 'Третий',
  'city.demoFloor3': 'Четвертое',
  'city.demoFloor4': 'Крыша',
  'city.demoWindow': 'Окно на третьем этаже',
  'city.demoRoom': 'Внутренняя комната на третьем этаже',
  'city.demoUp': 'Вверх по этажу',
  'city.demoDown': 'На пол .',
  'city.makeWay.polite': 'О, извините.',
  'city.makeWay.gruff': 'Эй, смотри, куда ходишь.',
  'city.makeWay.immovable': 'Я не буду двигаться.',
  'city.makeWay.busy': 'Осторожно.',
  'cascade.seoTitle': 'Каскадный деbugger',
  'cascade.title': 'Каскадный деbugger',
  'cascade.intro': 'Каждый прогресс, который формирует искусство, разрабатывается как два семейных дерева. Страна стиля проходит от системы до художественного директора. Страна наследника - это вся таксономия, от каждого корня к виду и родословной, которые на них сидят. Откройте любой ряд, чтобы прочитать его полный текст.',
  'cascade.readOnly': 'Ничто на этом экране не может изменить запрос.',
  'cascade.fetchedAt': 'Читать из API содержимого в {time}',
  'cascade.refresh': 'Прочтите еще раз .',
  'cascade.loading': 'Читая оба каскада...',
  'cascade.error': 'Не удалось прочитать каскады из API контента.',
  'cascade.forbidden': 'Этот экран предназначен для администраторов сайта. Ваш аккаунт зарегистрирован, но не имеет роли администратора.',
  'cascade.style.title': 'Каскад стилей',
  'cascade.style.subtitle': 'Система, издатель, линия продукции, настройка, тип медиа, книга и художественный директор. Каждый ряд наследует от более широких рядов выше него.',
  'cascade.style.focus': 'Следуйте за цепочкой',
  'cascade.style.counts': '{nodes} строки стиля, {edges} соединения, {media} медиа шаблоны',
  'cascade.taxa.title': 'Каскад наследников',
  'cascade.taxa.subtitle': 'Каждый узел добавляет свой собственный запрос ко всему, что он унаследует от узлов выше него.',
  'cascade.taxa.group': 'Немедленная группа',
  'cascade.taxa.find': 'Найти таксон или родословную',
  'cascade.taxa.findPlaceholder': 'Гомо, Террана, фамилия рода...',
  'cascade.taxa.counts': '{taxa} таксоны, {prompts} таксоновые сигналы, {lineages} родословные',
  'cascade.taxa.shardCounts': '{taxa} таксы, {prompts} пропорциональные ряды',
  'cascade.taxa.truncated': 'API контента ограничивает список запросов этого фрагмента, поэтому здесь могут отсутствовать некоторые строки.',
  'cascade.taxa.emptyShards': 'Осколки без таксонов: {names}',
  'cascade.taxa.orphans': 'Семьи, указывающие на таксон, не на каком-либо дереве',
  'cascade.taxa.noOwn': 'Для этой группы не было никакого предварительного сообщения.',
  'cascade.taxa.inherits': 'Наследие сверху',
  'cascade.taxa.inheritsNothing': 'Здесь начинается цепочка.',
  'cascade.taxa.through': 'Составленный через этот узел',
  'cascade.taxa.lineages': 'Родословные этого вида',
  'cascade.level.system': 'Система',
  'cascade.level.publisher': 'Издатель',
  'cascade.level.product_line': 'Линейка продуктов',
  'cascade.level.setting': 'Настройка',
  'cascade.level.media': 'Тип СМИ',
  'cascade.level.book': 'Книга',
  'cascade.level.art_director': 'Художественный директор',
  'cascade.empty.system': 'Никаких системных стилей на этой цепи.',
  'cascade.empty.publisher': 'Никакой строки по стилю издателя пока нет.',
  'cascade.empty.product_line': 'Никакой строки стиля линейки продуктов на этой цепи.',
  'cascade.empty.setting': 'Никакой строки стиля на этой цепи.',
  'cascade.empty.media': 'Никакие шаблоны типа медиа не применяются к этой цепочке.',
  'cascade.empty.book': 'Никакая строка стиля книги не зависит от этой настройки.',
  'cascade.empty.art_director': 'Ни один художественный директор не связан с этой цепочкой.',
  'cascade.missing': 'Лишний уровень',
  'cascade.others': 'Другие строки на этом уровне ({count})',
  'cascade.mediaSpeciesNote': '{count} шаблоны видов отображаются на стороне наследников, под их родом.',
  'cascade.field.id': 'ИД',
  'cascade.field.scope': 'охват',
  'cascade.field.scopeId': 'Идентификатор сферы действия',
  'cascade.field.group': 'группа',
  'cascade.field.mediaType': 'тип медиа',
  'cascade.field.prompt': 'немедленно',
  'cascade.field.negative': 'отрицательный',
  'cascade.field.defaults': 'неисправность',
  'cascade.field.refs': 'ссылочные изображения',
  'cascade.field.chars': '{count} символы',
  'cascade.field.empty': 'пустые',
  'cascade.facet.art_direction': 'Ядро',
  'cascade.facet.art_direction_character': 'Характер',
  'cascade.facet.art_direction_scene': 'Сцена',
  'cascade.facet.art_direction_interface': 'Интерфейс',
  'cascade.facet.art_direction_cartography': 'Картография',
  'cascade.facet.art_direction_audiobook': 'Аудиокнига',
  'cascade.facet.art_direction_movie': 'Фильм',
  'cascade.facet.art_direction_short': 'Краткое',
  'cascade.facet.art_direction_tvshow': 'Телешоу',
  'cascade.composed.title': 'Составленный для {name}',
  'cascade.composed.layers': 'Покрытия, от широкого до узкого',
  'cascade.composed.preview': 'Составленный запрос изображения',
  'cascade.composed.previewNote': 'Сборка на этом экране из рядов выше в каскадном порядке: стиль ядро, характерный аспект, шаблоны медиа, таксонные черты, затем строка печати генератор добавляет в код.',
  'cascade.composed.negative': 'Составленный отрицательный',
  'cascade.composed.fromCode': 'добавленный в код, не хранящийся ни в одном строке',
  'cascade.flags.duplicates': 'Сказал дважды.',
  'cascade.flags.conflicts': 'Негативные термины, которые также появляются в запросе',
  'cascade.flags.none': 'Никаких повторяющихся предложений и отрицательных терминов, которые противоречат запросу.',
  'cascade.flags.in': 'в {sources}',
  'cascade.source.styleCore': 'стильный центр',
  'cascade.source.styleCharacter': 'стильный характерный аспект',
  'cascade.source.media': 'Сборник медиа, {scope}',
  'cascade.source.taxon': 'таксон {rank} {value}',
  'cascade.source.printSafe': 'строка (код)',
  'cascade.rank.domain': 'домен',
  'cascade.rank.kingdom': 'королевство',
  'cascade.rank.phylum': 'филома',
  'cascade.rank.class': 'класс',
  'cascade.rank.ordem': 'порядок',
  'cascade.rank.family': 'семья',
  'cascade.rank.genus': 'род',
  'cascade.rank.species': 'виды',
  'cascade.rank.shard': 'осколки',
}
